import React from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { memberApi, imgUrl, errMsg } from "../lib/api";
import { useSite } from "../context/SiteContext";

const Head = ({ title, onAll }) => (
  <div className="flex items-center justify-between mt-6 mb-3">
    <h3 className="mem-brand text-[22px] flex items-center gap-2">{title} <span className="text-[#e8365f]">♥</span></h3>
    {onAll && <button onClick={onAll} className="mem-seeall">See all <ArrowRight className="w-4 h-4" /></button>}
  </div>
);

export default function RightRail({ home, go, onVoted }) {
  const { img } = useSite();
  const poll = home?.poll;
  const vote = async (i) => {
    try { await memberApi.post(`/member/polls/${poll.id}/vote`, { option: i }); toast.success("Vote saved"); onVoted(); }
    catch (e) { toast.error(errMsg(e, "Could not vote")); }
  };
  return (
    <aside className="hidden xl:block w-[340px] shrink-0 border-l border-[#f1dfe0] overflow-y-auto mem-scroll h-[calc(100vh-24px)] p-3" data-testid="mem-right-rail">
      <div className="relative rounded-xl overflow-hidden h-[280px]">
        <img src={img("hero", "/img/hero_clean.jpg")} alt="" className="w-full h-full object-cover object-[70%_30%]" />
        <p className="absolute top-8 right-5 mem-hand text-white text-[30px] leading-[1.0] text-right -rotate-[16deg] drop-shadow-[0_2px_6px_rgba(0,0,0,.5)]">This is<br />our little<br />corner ♡</p>
      </div>

      <Head title="From Me" onAll={() => go("from-me")} />
      <div className="grid grid-cols-4 gap-2">
        {(home?.from_me || []).flatMap((p) => p.images).slice(0, 4).map((u, i) => (
          <button key={i} onClick={() => go("from-me")} className="aspect-[3/4] rounded-lg overflow-hidden"><img src={imgUrl(u)} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" /></button>
        ))}
      </div>

      {poll && (
        <>
          <Head title="Choose for Me" />
          <div className="flex gap-3" data-testid="rail-poll">
            {poll.images?.[0] && <img src={imgUrl(poll.images[0])} alt="" className="w-[140px] h-[160px] rounded-lg object-cover" />}
            <div className="flex-1 min-w-0">
              <p className="text-[13px] leading-snug text-[#2a2023] mb-2">{poll.title}</p>
              <div className="space-y-2">
                {poll.options.map((o, i) => (
                  <button key={i} onClick={() => vote(i)} data-testid={`rail-poll-opt-${i}`} className={`mem-opt ${poll.my_vote === i ? "mem-opt-on" : ""}`}>{o}</button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}

      {home?.update && (
        <>
          <Head title="My Updates" onAll={() => go("updates")} />
          <div className="flex gap-3">
            {home.update.images?.[0] && <img src={imgUrl(home.update.images[0])} alt="" className="w-[160px] h-[150px] rounded-lg object-cover" />}
            <div className="flex-1 min-w-0">
              <p className="text-[12px] leading-[1.45] text-[#3a2d30] line-clamp-6">{home.update.text}</p>
              <p className="mem-hand text-[24px] mt-1">- Maya</p>
            </div>
          </div>
        </>
      )}

    </aside>
  );
}
